export * from './abteilung-gespeichert.interface';
